import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabsbookingpune() {



const cardData = {
keyword: "Luxury Cabs Booking Pune",
headingDescription: "Citysky Cabs offers premium and luxury cab options in Pune for airport transfers, corporate travel, weddings, family journeys, group transportation, local sightseeing and outstation trips. Spacious premium vehicles with professional driver support provide a comfortable private travel experience for passengers who value convenience, refined interiors and flexible trip planning. From one-way and round-trip journeys to special events and long-distance travel, luxury cab arrangements can be planned around different travel requirements.",


topPlaces: [
    {
        title: "Pune Airport",
        description: "Pune Airport is a frequent destination for business executives, families, tourists and visitors arriving in the city. A luxury cab provides a comfortable private transfer between the airport, hotels, residences and corporate offices. Spacious seating and luggage capacity make premium transportation convenient for passengers travelling with multiple bags."
    },
    {
        title: "Hinjewadi",
        description: "Hinjewadi is a major technology and corporate hub where executives and business visitors frequently travel for meetings and professional assignments. Luxury cabs are suitable for airport transfers, client transportation and office travel from this area. Premium private transportation also provides convenient seating for small corporate groups."
    },
    {
        title: "Kharadi",
        description: "Kharadi is an important business and technology destination in Pune with numerous offices, commercial establishments and hotels. Premium cab services can be used for executive travel, client visits, airport transfers and corporate meetings. A spacious luxury vehicle is particularly useful when business travellers need comfortable transportation with luggage."
    },
    {
        title: "Koregaon Park",
        description: "Koregaon Park is known for hotels, restaurants, commercial establishments and premium residential spaces, making it a popular destination for visitors and business travellers. Luxury cabs provide a convenient private travel option for airport transfers, local movement and special occasions. Passengers can travel comfortably between multiple Pune destinations."
    },
    {
        title: "Baner",
        description: "Baner has a growing mix of corporate offices, hotels, residential communities and lifestyle destinations. Luxury cab transportation can support business meetings, family travel, airport journeys and special events from this locality. Premium vehicles provide a comfortable environment for passengers who prefer a more refined private travel experience."
    },
    {
        title: "Lonavala",
        description: "Lonavala is a popular weekend destination from Pune, attracting families, couples and groups throughout the year. A luxury cab provides comfortable private transportation for travellers carrying luggage and planning a relaxed leisure trip. The vehicle can also be used for sightseeing and flexible travel around nearby attractions."
    },
    {
        title: "Mahabaleshwar",
        description: "Mahabaleshwar is a well-known hill destination suitable for family holidays, weekend breaks and special trips from Pune. Luxury cab transportation allows travellers to enjoy a spacious private journey while carrying luggage comfortably. The trip can also include nearby Panchgani and other sightseeing points according to the itinerary."
    },
    {
        title: "Mumbai",
        description: "Mumbai is a major destination for corporate meetings, shopping, family visits, events and business travel from Pune. A luxury cab offers a convenient private option for intercity transportation, especially for passengers looking for additional comfort. One-way and round-trip arrangements can be planned according to the travel schedule."
    },
    {
        title: "Nashik",
        description: "Nashik attracts visitors for religious tours, vineyards, family outings and business travel. A premium private cab provides comfortable transportation from Pune for travellers who prefer spacious seating and a dedicated vehicle. The journey can be combined with destinations such as Trimbakeshwar, Sula Vineyards and other local attractions."
    },
    {
        title: "Goa",
        description: "Goa is a popular long-distance leisure destination for families, friends and groups travelling from Pune. A luxury cab provides a comfortable private option for extended road journeys with luggage. Travellers can plan one-way or round-trip transportation according to their holiday schedule and preferred travel arrangements."
    }
],

services: [
    {
        name: "Luxury Cab Booking Pune",
        description: "Luxury Cab Booking Pune provides a premium private transportation option for passengers looking for greater comfort during local and outstation journeys. It is suitable for airport transfers, corporate travel, family trips, weddings and special occasions. Spacious interiors and dedicated travel arrangements make the journey more convenient."
    },
    {
        name: "Luxury Taxi Booking Pune",
        description: "Luxury Taxi Booking Pune is suitable for travellers who prefer premium transportation with comfortable seating and private travel convenience. The service can be used for business meetings, airport transfers, family journeys and special events. It is also practical for passengers carrying luggage or travelling across multiple Pune locations."
    },
    {
        name: "Luxury Car Rental Pune",
        description: "Luxury Car Rental Pune provides premium vehicle options for planned travel within Pune and nearby destinations. It can support corporate requirements, weddings, family functions, sightseeing and special occasions. A dedicated luxury car offers passengers a comfortable travel environment with professional driver support."
    },
    {
        name: "Luxury Cab on Rent Pune",
        description: "Luxury Cab on Rent Pune is useful for travellers who need a premium vehicle for a specific journey or occasion. The service can be arranged for local travel, airport transportation, corporate requirements, family outings and events. Spacious seating and a private vehicle make the overall travel experience more comfortable."
    },
    {
        name: "Luxury Taxi on Rent Pune",
        description: "Luxury Taxi on Rent Pune offers a premium private transportation option for business and leisure travel. Passengers can use the vehicle for airport transfers, meetings, sightseeing, family trips and special functions. The spacious cabin provides comfortable travel while allowing the itinerary to be planned around the passenger's requirements."
    },
    {
        name: "Premium Cab Service Pune",
        description: "Premium Cab Service Pune is designed for passengers seeking a more comfortable and refined private transportation experience. It can be used for executive travel, airport journeys, family trips, weddings and local sightseeing. Premium vehicles are suitable when passengers want spacious seating and convenient point-to-point transportation."
    },
    {
        name: "Premium Taxi Service Pune",
        description: "Premium Taxi Service Pune provides comfortable private transportation for corporate and personal travel requirements. The service is suitable for airport transfers, business meetings, family journeys and special events. Travellers can benefit from spacious interiors and dedicated transportation without relying on shared vehicles."
    },
    {
        name: "Luxury Car Hire Pune",
        description: "Luxury Car Hire Pune allows travellers to arrange a premium vehicle for planned journeys and special occasions. It is suitable for corporate executives, weddings, family celebrations, airport transfers and leisure travel. A private luxury car provides a comfortable setting for passengers travelling across Pune or to nearby destinations."
    },
    {
        name: "Luxury Cab Rental Service Pune",
        description: "Luxury Cab Rental Service Pune provides flexible premium transportation for different travel requirements. Passengers can use the service for local movement, outstation journeys, corporate assignments, airport transfers and events. The spacious private vehicle offers convenience for individuals, families and small groups."
    },
    {
        name: "Luxury Cars for Outstation Pune",
        description: "Luxury Cars for Outstation Pune are suitable for passengers planning comfortable long-distance journeys from Pune to destinations such as Mumbai, Goa, Mahabaleshwar and Nashik. Premium vehicles provide a spacious private environment for extended road travel. They are useful for families, executives and groups travelling with luggage."
    },
    {
        name: "Luxury Cab for Airport Pune",
        description: "Luxury Cab for Airport Pune offers premium private transportation for passengers travelling to or from Pune Airport. It is suitable for executives, families, international travellers and groups carrying luggage. The spacious vehicle provides a comfortable transfer between the airport, hotels, offices and residential locations."
    },
    {
        name: "Luxury Cab for Corporate Travel Pune",
        description: "Luxury Cab for Corporate Travel Pune provides comfortable transportation for executives, employees, clients and business visitors. The premium vehicle is suitable for meetings, airport transfers, office visits, conferences and site travel. Private transportation also allows corporate passengers to maintain a convenient and organized schedule."
    },
    {
        name: "Luxury Cab for Wedding Pune",
        description: "Luxury Cab for Wedding Pune is suitable for transporting family members, guests and wedding participants between homes, hotels and venues. Premium vehicles add comfort to special-event transportation while providing useful space for passengers and personal belongings. The service can support different movements throughout the wedding itinerary."
    },
    {
        name: "Luxury Cab for Family Travel Pune",
        description: "Luxury Cab for Family Travel Pune provides a spacious private transportation option for families planning local or long-distance journeys. Comfortable seating and luggage capacity are useful for holidays, family functions and weekend trips. Travelling together in one premium vehicle also makes group movement more convenient."
    },
    {
        name: "Luxury Cab for Group Travel Pune",
        description: "Luxury Cab for Group Travel Pune is suitable for friends, relatives and small groups who prefer to travel together in a premium private vehicle. The spacious cabin can accommodate passengers and luggage for sightseeing, events, airport journeys and outstation trips. It provides a convenient alternative to arranging several smaller cars."
    },
    {
        name: "Luxury Cab for Events Pune",
        description: "Luxury Cab for Events Pune provides premium transportation for guests and participants attending conferences, celebrations, exhibitions and other events. A private luxury vehicle can be used for movement between hotels, venues, offices and airports. The comfortable interior is suitable for special occasions requiring organized passenger transportation."
    },
    {
        name: "Luxury Cab for Local Sightseeing Pune",
        description: "Luxury Cab for Local Sightseeing Pune allows visitors and residents to explore Pune attractions in a comfortable private vehicle. It is suitable for family outings, cultural tours and customized sightseeing plans. Passengers can organize multiple destinations during the day without depending on fixed public transportation schedules."
    },
    {
        name: "Affordable Luxury Cab Pune",
        description: "Affordable Luxury Cab Pune provides travellers with a premium private transportation option while keeping the trip practical for planned budgets. It can be used for airport travel, corporate journeys, family trips, events and outstation transportation. Travelling together in one vehicle can also be convenient for small groups."
    },
    {
        name: "Luxury Cab Near Me Pune",
        description: "Luxury Cab Near Me Pune is useful for passengers searching for premium private transportation around their Pune location. The service can support airport transfers, business travel, family outings, local sightseeing and special events. A spacious luxury vehicle provides a comfortable option for individuals and groups."
    },
    {
        name: "Luxury Outstation Taxi Pune",
        description: "Luxury Outstation Taxi Pune provides premium private transportation for long-distance journeys from Pune to nearby cities and leisure destinations. The spacious vehicle is suitable for families, executives and groups who want a comfortable road journey with luggage. One-way and return travel arrangements can be planned around the itinerary."
    },
    {
        name: "Premium Car Rental with Driver Pune",
        description: "Premium Car Rental with Driver Pune provides a dedicated luxury vehicle with professional driver support for business and personal travel. It can be used for corporate meetings, airport transfers, weddings, family functions, sightseeing and outstation journeys. The arrangement allows passengers to focus on their travel plans without managing the drive themselves."
    },
    {
        name: "Luxury One Way Cab Pune",
        description: "Luxury One Way Cab Pune is suitable for travellers who need premium private transportation in a single direction. It can be used for airport drops, intercity transfers, relocation journeys and business travel. The comfortable vehicle provides a convenient option for passengers who do not require a return cab."
    },
    {
        name: "Luxury Round Trip Cab Pune",
        description: "Luxury Round Trip Cab Pune is designed for passengers who require premium transportation for both onward and return journeys. It works well for family vacations, corporate visits, sightseeing trips and weekend travel. Travelling in the same private luxury vehicle provides convenient group transportation throughout the planned itinerary."
    },
    {
        name: "Luxury Airport Transfer Pune",
        description: "Luxury Airport Transfer Pune provides premium transportation between Pune Airport and homes, hotels, offices or other destinations. The service is suitable for executives, families and groups travelling with luggage. A dedicated luxury vehicle offers comfortable seating for both airport pickups and scheduled departures."
    },
    {
        name: "Luxury Tourist Cab Pune",
        description: "Luxury Tourist Cab Pune is suitable for visitors who want to explore Pune and nearby destinations in a comfortable private vehicle. It can support local sightseeing, weekend trips, family tours and outstation travel. The spacious premium vehicle allows travellers to organize multiple attractions around their preferred itinerary."
    }
],

tableData: [
    ["Luxury Cab Booking Pune"],
    ["Luxury Taxi Booking Pune"],
    ["Luxury Car Rental Pune"],
    ["Luxury Cab on Rent Pune"],
    ["Luxury Taxi on Rent Pune"],
    ["Premium Cab Service Pune"],
    ["Premium Taxi Service Pune"],
    ["Luxury Car Hire Pune"],
    ["Luxury Cab Rental Service Pune"],
    ["Luxury Cars for Outstation Pune"],
    ["Luxury Cab for Airport Pune"],
    ["Luxury Cab for Corporate Travel Pune"],
    ["Luxury Cab for Wedding Pune"],
    ["Luxury Cab for Family Travel Pune"],
    ["Luxury Cab for Group Travel Pune"],
    ["Luxury Cab for Events Pune"],
    ["Luxury Cab for Local Sightseeing Pune"],
    ["Affordable Luxury Cab Pune"],
    ["Luxury Cab Near Me Pune"],
    ["Luxury Outstation Taxi Pune"],
    ["Premium Car Rental with Driver Pune"],
    ["Luxury One Way Cab Pune"],
    ["Luxury Round Trip Cab Pune"],
    ["Luxury Airport Transfer Pune"],
    ["Luxury Tourist Cab Pune"]
],

whychoose: [
    {
        WhyChooseheading: "Premium Travel Comfort",
        WhyChoosedescription: "Luxury cab transportation provides passengers with a spacious and comfortable private environment for local and long-distance journeys. It is suitable for travellers who prefer upgraded interiors, convenient seating and a more refined travel experience."
    },
    {
        WhyChooseheading: "Suitable for Business Executives",
        WhyChoosedescription: "Corporate travellers can use luxury cabs for airport transfers, client meetings, office visits and business events. Private premium transportation provides comfortable travel for executives and small teams moving between important business locations."
    },
    {
        WhyChooseheading: "Convenient Airport Transfers",
        WhyChoosedescription: "Luxury cabs are useful for passengers travelling between Pune Airport and hotels, residences or corporate offices. Spacious luggage capacity and private transportation make airport journeys more convenient for families, executives and groups."
    },
    {
        WhyChooseheading: "Ideal for Special Occasions",
        WhyChoosedescription: "Weddings, celebrations, corporate functions and other important events often require comfortable guest transportation. Premium cabs can provide dedicated movement between hotels, homes, venues and other locations included in the event schedule."
    },
    {
        WhyChooseheading: "Comfortable Outstation Journeys",
        WhyChoosedescription: "For longer journeys from Pune to destinations such as Mumbai, Goa, Mahabaleshwar and Nashik, a spacious luxury vehicle provides a comfortable private travel environment. It is suitable for families, executives and groups carrying luggage."
    },
    {
        WhyChooseheading: "Flexible One-Way or Return Trips",
        WhyChoosedescription: "Different travel requirements can be accommodated through one-way or round-trip luxury cab arrangements. This flexibility is useful for airport drops, intercity transfers, weekend holidays, business visits and sightseeing itineraries."
    },
    {
        WhyChooseheading: "Private Group Transportation",
        WhyChoosedescription: "Families, friends and small groups can travel together in one premium vehicle rather than arranging several smaller cabs. The spacious cabin provides useful passenger and luggage capacity for airport journeys, events, sightseeing and outstation travel."
    },
    {
        WhyChooseheading: "Driver-Assisted Travel",
        WhyChoosedescription: "Premium car rental with driver support allows passengers to focus on their business or leisure plans instead of managing the journey themselves. It is particularly useful for executives, families, special occasions and multi-stop travel schedules."
    }
]


};













const faqData = [
{
question: "Can I book a luxury cab in Pune for local travel?",
answer: "Luxury cabs can be arranged in Pune for business meetings, hotel transfers, special occasions, airport travel, corporate events, sightseeing, and private city journeys. Citysky Cabs can coordinate the cab according to your pickup location, destination, travel date, passenger count, and required travel duration."
},
{
question: "What occasions are suitable for luxury cab booking in Pune?",
answer: "A luxury cab can be considered for weddings, corporate functions, executive travel, airport transfers, family celebrations, hotel transportation, VIP guest movements, and special outings. The booking can be planned around the event schedule and the specific transportation requirements of the passengers."
},
{
question: "Can I book a luxury cab for Pune Airport transfers?",
answer: "Luxury airport transfers can be arranged for passengers travelling to or from Pune Airport. The service can be useful for corporate executives, families, guests, and small groups who prefer a premium vehicle for their airport journey. Sharing flight timing and pickup details helps coordinate the transfer."
},
{
question: "Are luxury cabs available for corporate travel in Pune?",
answer: "Corporate travellers can arrange luxury cabs for client meetings, executive transportation, conferences, business events, office transfers, and guest movements. Citysky Cabs can plan the travel schedule around meeting locations, airport or hotel pickups, passenger requirements, and business appointments."
},
{
question: "Can I hire a luxury cab for a wedding in Pune?",
answer: "Luxury cab arrangements can be used for weddings, receptions, engagement functions, and other celebrations where families need dedicated transportation. The cab can be planned for transfers between homes, hotels, event venues, railway stations, airports, and other locations included in the occasion itinerary."
},
{
question: "Can I book a luxury cab for outstation travel from Pune?",
answer: "Luxury cab services can be considered for outstation journeys from Pune to destinations such as Mumbai, Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, and other cities. Depending on the itinerary, travellers can discuss one-way, round-trip, or multi-day transportation requirements."
},
{
question: "Can companies arrange luxury cabs for visiting clients in Pune?",
answer: "Businesses can arrange premium cab transportation for visiting clients, delegates, executives, and other guests. Transfers can be planned between airports, hotels, offices, restaurants, conference venues, and meeting locations according to the guest's business itinerary."
},
{
question: "Can I hire a luxury cab for a special celebration?",
answer: "A luxury cab can be arranged for birthdays, anniversaries, engagement functions, family celebrations, private dinners, and other special occasions. Providing the event locations, travel date, passenger count, and required service duration helps Citysky Cabs coordinate the transportation around the celebration."
},
{
question: "Can a luxury cab be booked for Pune sightseeing?",
answer: "Travellers can consider a luxury cab for private sightseeing around Pune or for planned journeys to nearby destinations. A dedicated vehicle allows the group to follow its own itinerary, with the travel arrangement coordinated around the preferred sightseeing locations and available time."
},
{
question: "How can I book a luxury cab in Pune with Citysky Cabs?",
answer: "To enquire about a luxury cab, share your pickup location, destination, travel date, passenger count, preferred timing, and purpose of travel. Citysky Cabs can coordinate the luxury cab arrangement according to your airport, corporate, wedding, local, sightseeing, or outstation requirements."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Arvind Malhotra",
feedback:
"I needed a premium cab in Pune for visiting business clients who were travelling between the airport, hotel, and our office. We had a fixed schedule with several transfers, so I wanted one dedicated vehicle for the day. Citysky Cabs understood the itinerary and arranged the transportation around our planned meetings.",
rating: 5
},
{
id: 2,
name: "Miss. Tanvi Deshpande",
feedback:
"For my sister's wedding, we arranged a luxury cab for transfers between the hotel and different function venues. The vehicle was mainly needed for family members who had several movements during the event. Citysky Cabs made the booking process straightforward after we shared the locations and schedule.",
rating: 5
}
];

































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Cabs Booking Pune",
  "image": "https://www.cityskycab.in/assets/images/luxury-cabs-booking-pune.webp",
  "description": "Luxury Cabs Booking Pune from Citysky Cabs is suited for travellers who prefer a more comfortable and premium experience for airport transfers, corporate travel, special occasions, family journeys and outstation trips. The service includes Luxury Cab Booking Pune, Luxury Taxi Booking Pune, Luxury Car Rental Pune, Luxury Cab on Rent Pune and Luxury Taxi on Rent Pune options. Premium vehicles offer comfortable interiors, air conditioning and spacious seating for passengers who want a relaxed journey around Pune or on longer routes. Customers can arrange private city travel, airport transfers, business transportation, events and outstation journeys according to their preferred schedule and pickup location.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/luxury-cabs-booking-pune"
  }
};









    return (
        <div>

<Helmet>
  <title>
    Luxury Cabs Booking Pune | Premium Cab Service for Airport, Corporate & Outstation Travel | +91 8554819191
  </title>

  <meta
    name="description"
    content="Choose Luxury Cabs in Pune from Citysky Cabs for airport transfers, corporate travel, special occasions and outstation journeys. Enjoy premium vehicles, AC comfort, spacious seating and professional service."
  />

  <meta
    name="keywords"
    content="Luxury Cab Booking Pune, Luxury Taxi Booking Pune, Luxury Car Rental Pune, Luxury Cab on Rent Pune, Luxury Taxi on Rent Pune, Premium Cab Service Pune, Luxury Cabs Booking Pune, luxury taxi Pune, premium taxi Pune, luxury car hire Pune, premium cab rental Pune, luxury airport cab Pune, premium airport taxi Pune, luxury corporate cab Pune, premium outstation cab Pune, luxury car with driver Pune, premium AC cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxurycabsbookingpune;